export default __webpack_public_path__ + "static/media/background.734f15e0.png";